import React from "react";

import { Collapse, TableCell, TableRow, Typography } from "@mui/material";
import { HubIcon } from "../../components";

import { StyledStack, StyledSubStack, StyledLineItemsLabel } from "./styles";
import CustomerOrderLineItemsTable from "./CustomerOrderLineItemsTable";

const CustomerOrdersJobs = ({ colSpan = 9, id = "", isOpen = false }) => {
  const sx = isOpen
    ? { ":hover": { backgroundColor: "transparent !important" } }
    : { border: "none" };

  return (
    <TableRow sx={sx}>
      <TableCell colSpan={colSpan} sx={{ padding: "0px !important" }}>
        <Collapse in={isOpen}>
          <StyledSubStack>
            <StyledStack>
              <StyledLineItemsLabel>
                <HubIcon icon="List" size="12px" />
                <Typography variant="boldCaption">Line Items</Typography>
              </StyledLineItemsLabel>
              {isOpen && <CustomerOrderLineItemsTable id={id} />}
            </StyledStack>
          </StyledSubStack>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default CustomerOrdersJobs;
